import React, { useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import { Popup } from 'reactjs-popup';

import Button from "../../Parts/Button";
import Fileupload from "../../Parts/FileUploader";

import { WorkingContractor } from "../contractors";

/* eslint-disable camelcase */
const SalesTaxEdit = ({
	contractorId, onSave, contractor
}) => {
	const [open, setOpen] = useState(false);

	const [localObj, setLocalObj] = useState<WorkingContractor>({
		is_exempt: false,
		exemption_type: '',
		tax_exemption_number: '',
		tax_certificate_location: ''
	});

	const {
		is_exempt = contractor.sales_tax_exempt_status === 'tax_exempt',
		exemption_type = contractor.sales_tax_exempt_reason ?? '0',
		tax_exemption_number = contractor.sales_tax_exempt_certificate_number,
		tax_certificate_location = contractor.sales_tax_exempt_certificate_location,
	} = localObj;

	const setObj = (newObj) => {
		setLocalObj({ ...localObj, ...newObj });
	};

	const save = () => {
		setOpen(false);

		onSave && onSave(localObj);
	};

	return (
		<>
			<Button color="green" onClick={() => setOpen(true)}>
				Edit
			</Button>
			<Popup open={open} onClose={() => setOpen(false)} className="mobile-modal">
				<Container className="local-bootstrap">
					<Row>
						<Col>
							<h4 className="text-green">Sales Tax Edit</h4>
						</Col>
					</Row>
					<Row>
						<Col>
							<Row>
								<Col>
									<label>Is Exempt?</label>
								</Col>
							</Row>
							<Row>
								<Col>
									<input
										type="checkbox"
										checked={is_exempt}
										onChange={(e) => setObj({ is_exempt: e.target.checked })}
									/>
								</Col>
							</Row>
						</Col>
						<Col>
							<Row>
								<Col>
									<label>Exemption Type</label>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Control
										size="sm"
										as="select"
										onChange={(e) => setObj({ exemption_type: e.target.value })}
										value={exemption_type}
									>
										<option value="">Select Reason</option>
										<option value="government">Government</option>
										<option value="nonprofit">Non-Profit</option>
										<option value="wholesale">Wholesale</option>
									</Form.Control>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row>
						<Col>
							<Row>
								<Col>
									<label>Tax Exemption Number</label>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Control
										size="sm"
										value={tax_exemption_number}
										onChange={(e) =>
											setObj({
												tax_exemption_number: e.target.value,
											})}
									/>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row className="mt-2">
						<Col>
							<Fileupload
								certType="state"
								entityType="organization"
								entityID={contractorId}
								onSuccess={(link) => {
									setObj({ tax_certificate_location: link });
								}}
							/>
						</Col>
					</Row>
					<Row className="mt-4">
						<Col>
							<Button
								color="grey"
								onClick={() => {
									setOpen(false);
								}}
							>
								Exit
							</Button>
						</Col>
						<Col className="text-end">
							<Button
								disabled={!tax_certificate_location}
								color="green"
								onClick={() => {
									save();
								}}
							>
								Save
							</Button>
						</Col>
					</Row>
				</Container>
			</Popup>
		</>
	);
};

export default SalesTaxEdit;
